import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  padding-bottom: 12px;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 16px;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.12);
  }

  & > svg {
    display: none;
  }

  @media (min-width: 769px) {
    & > svg {
      display: block;
      flex-shrink: 0;
      min-width: 14px;
      min-height: 14px;
      color: #0b29fb;
      cursor: pointer;
    }
  }
`;

export const ControlsWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  width: 100%;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    width: auto;
  }

  @media (min-width: 769px) and (max-width: 920px) {
    flex-wrap: wrap;
  }
`;

export const Separator = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block;
    height: 34px;
    width: 0;
    border-left: 1px dashed rgba(0, 0, 0, 0.2);
    margin: 0 2px;
    flex-shrink: 0;
  }
`;

export const Title = styled.div`
  font-family: 'Mangueira Bold', 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: #262626;
  flex-shrink: 0;
`;

export const ViewModeRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  > div {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
  }

  > div > span:first-of-type {
    font-size: 13px;
    color: #575757;
    white-space: nowrap;
  }

  @media (min-width: 769px) {
    width: auto;

    > div > span:first-of-type {
      font-size: 14px;
      color: #262626;
    }
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;

  > div:first-of-type {
    flex: 1;
    min-width: 0;
  }

  > div:last-of-type {
    flex-shrink: 0;
    width: auto;

    button {
      width: auto;
      min-width: 132px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  @media (min-width: 769px) {
    width: auto;

    > div:last-of-type button {
      min-width: 148px;
    }
  }
`;
